import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.851 4.353a1.204 1.204 0 00-1.702 0l-6.796 6.796c-.47.47-.47 1.232 0 1.702l6.796 6.796c.47.47 1.232.47 1.702 0l6.796-6.796c.47-.47.47-1.232 0-1.702l-6.796-6.796zm1.414-1.415l6.797 6.797a3.204 3.204 0 010 4.53l-6.797 6.797a3.204 3.204 0 01-4.53 0l-6.797-6.797a3.204 3.204 0 010-4.53l6.797-6.797a3.204 3.204 0 014.53 0zM11.02 13.834c0-1.8 2.082-1.8 2.082-3.103 0-.497-.429-.931-1.102-.931-1.163 0-1.47.993-1.47.993L9 10.11S9.612 8 12.061 8C13.837 8 15 9.18 15 10.483c0 2.296-2.204 2.296-2.204 3.91h-1.653s-.123-.31-.123-.559zm-.122 2.235c0-.497.429-.931.98-.931.55 0 .98.434.98.931 0 .497-.43.931-.98.931-.551 0-.98-.434-.98-.931z"
    />
  </svg>
);
